"use client";

import { useQuery } from "@tanstack/react-query";

import { useAccount } from "#/store/wallet/account/account";

import { fetchServerAccount } from "../kyan.service";

export const useServerAccount = () => {
  const { account } = useAccount();

  const {
    data: serverAccount,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["fetchServerAccount", account],
    queryFn: () => fetchServerAccount(),
    enabled: Boolean(account),
  });

  return {
    serverAccount,
    isLoading,
    refetch,
  };
};
